// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"ce324e1f","453":"dfcbb50c"}[chunkId] + ".chunk.js";
};